module.exports = __webpack_public_path__ + "static/media/f_passport.b6c71d84.svg";